import { render } from "./AppointmentsCalendar.vue?vue&type=template&id=29654a30&scoped=true"
import script from "./AppointmentsCalendar.vue?vue&type=script&lang=js"
export * from "./AppointmentsCalendar.vue?vue&type=script&lang=js"

import "./AppointmentsCalendar.vue?vue&type=style&index=0&id=29654a30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29654a30"]])

export default __exports__